export default __webpack_public_path__ + "static/media/estimation.46c2d602.pdf";